export const selectLoyaltyTypeByService = (state, serviceId) =>
  state.getIn(['loyalty', 'loyaltyTypeByService', serviceId?.toString(), 'type']);

export const selectLoyaltyUser = state => state.getIn(['loyalty', 'user']);

export const selectLoyaltySpend = state => state.getIn(['loyalty', 'loyaltySpend']);
